import { createFileRoute } from '@tanstack/react-router';
import { WarehouseOrderDetailPage } from '@/pages/Warehouse/OrderDetailPage';

export const Route = createFileRoute('/_admin/warehouse/orders/$orderId')({
  component: WarehouseOrderDetailPage,
});
